import { Box } from '@mui/material';
import { type ComponentProps, lazy, memo, Suspense } from 'react';
import ErrorBoundary from '@/components/ErrorBoundary';
import { combineSx } from '@/utils/combineSx';
import { cardVariants } from '../../theme/cardStyles';

const LazyMapBox = lazy(() => import('./Map').then(module => ({ default: module.MapBox })));

const mapStyles = {
  container: combineSx(
    {
      height: 'clamp(10rem, 100%, 20rem)',
      cursor: 'pointer',
      overflow: 'hidden',
      '--padding': 0,
    },
    cardVariants({ interactive: true, padding: 'none' }),
  ),
};

type LazyLoadedMapProp = ComponentProps<typeof Box>;

const LazyLoadedMap = memo(({ sx, ...props }: LazyLoadedMapProp) => {
  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <Box
            sx={combineSx(mapStyles.container, sx)}
            data-id='asset-details-map-loading'
            aria-hidden='true'
          />
        }
      >
        <LazyMapBox {...props} sx={combineSx(mapStyles.container, sx)} />
      </Suspense>
    </ErrorBoundary>
  );
});

export { LazyLoadedMap };
